export default __webpack_public_path__ + "static/media/cipolla1.fe9e8574.png";